import { render } from "./NavbarHome3.vue?vue&type=template&id=132ab27e"
import script from "./NavbarHome3.vue?vue&type=script&lang=js"
export * from "./NavbarHome3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__